export default "/fonts/bauhs93-webfont.eot?d8536a4cd0a849ab64eb37b0ee662f3f";